import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class EmaService {
    constructor(private http: HttpRequestService) {
    }

    save(model) {
        return this.http.put('ema', model).map(res => {
            return res.json();
        });
    }

    getConditions(dataRequest: any) {
        return this.http.get('ema/conditions' + this.parseParamToString(dataRequest))
            .map(res => {
                return res.json();
            });
    }

    parseParamToString(param: any) {
        let queryString = `?`;
        for (var property in param) {
            if (param.hasOwnProperty(property)) {
                queryString += `&${property}=${param[property]}`;
            }
        }
        return queryString;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/ema.service.ts